var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllWelcomecollage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 325,
    height: 97.836,
    viewBox: "0 0 325 97.836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ill_welcomecollage",
    transform: "translate(162.5 48.918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ill_welcomecollage-2",
    "data-name": "ill_welcomecollage",
    transform: "translate(-162.5 -48.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117795",
    "data-name": "Path 117795",
    d: "M35.565,91.718,19.81,97.774v-16.1a16.311,16.311,0,0,1-5.46-11.794c-.238-9.243,7.595-16.807,16.877-16.807h5.857A17.749,17.749,0,0,1,51.6,60.6c1.272,1.809.994,7.547.994,7.547s4.507,5.808,5.222,7.4a2.73,2.73,0,0,1-2.5,3.832H51.578v8.438a5.46,5.46,0,0,1-5.46,5.46H42.574V98.24Z",
    transform: "translate(-4.679 -0.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117796",
    "data-name": "Path 117796",
    d: "M312.5,50.154c2.869-15.557,27.648-29.038,7.942-39.829s-56.984-12.737-82.538,5.281S193.1-4.418,153.96,2.174C115.4,8.667,99.24,20.918,74.877,12.827,44.707,2.81,14.726-4.2,7.975,13.3c-12.638,32.87,15.586,20.778-.208,50.243-7.5,13.9-.913,23.3,11.973,28.691V81.317A16.311,16.311,0,0,1,14.279,69.5C14.041,60.261,21.874,52.7,31.156,52.7h5.857a17.749,17.749,0,0,1,14.513,7.533c1.272,1.809.994,7.547.994,7.547s4.507,5.808,5.222,7.4A2.73,2.73,0,0,1,55.241,79H51.508v8.438a5.46,5.46,0,0,1-5.46,5.46H42.5V97.34c18.862,1.757,40.8-.943,55.416-7.287,53.192-23.092,66.276,2.978,114.008,5.52,46.431,2.5,50.392-36.007,71.776-13.432,15.835,16.708,43.135,13.015,44.277,2.194S309.833,64.639,312.5,50.154Z",
    transform: "translate(-4.608 -0.556)",
    fill: "#bad3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117797",
    "data-name": "Path 117797",
    d: "M98.463,40.633H60.5a27.34,27.34,0,0,1,1.678-6.86,26.914,26.914,0,0,1,3.256-6.79,10.087,10.087,0,0,0,.993-1.827l.993-4.229v-1.39a11.853,11.853,0,0,0-.338-2.829L65.394,12.5a21.98,21.98,0,0,1-1.35-4.815L63.2,2.65H95.654L94.81,7.683A21.98,21.98,0,0,1,93.46,12.5l-1.688,4.229a11.853,11.853,0,0,0-.338,2.829v.764a12.906,12.906,0,0,0,.079,1.4A11.844,11.844,0,0,0,93.5,27c.218.308.417.625.606.943a28.482,28.482,0,0,1,2.68,5.827,27.34,27.34,0,0,1,1.678,6.86Z",
    transform: "translate(-5.013 -0.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117798",
    "data-name": "Path 117798",
    d: "M82.873,24.455V35.7c0,1.271-1.3,2.978-4.676,2.482s-1.539-7.346-1.717-9.133-3.584-.943-4.06.993-2.452,5.609-2.9,1.549a4.815,4.815,0,0,0-4.05-4.457,10.087,10.087,0,0,0,.993-1.827l.993-4.229,11.973.7Z",
    transform: "translate(-5.049 -0.699)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117799",
    "data-name": "Path 117799",
    d: "M94.31,28.085a19.379,19.379,0,0,0-5.341.129c-2.373.566-4.219-1.578-4.219-3.753,0-1.162,3.574-2.035,6.949-2.6a11.844,11.844,0,0,0,1.986,5.281A7.751,7.751,0,0,1,94.31,28.085Z",
    transform: "translate(-5.189 -0.704)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117800",
    "data-name": "Path 117800",
    d: "M98.682,41.618a.993.993,0,0,1-.993-.993c0-.794-.278-2.571-1.618-6.522a25.534,25.534,0,0,0-3.087-6.532,12.618,12.618,0,0,1-2.273-7.247v-.774A12.637,12.637,0,0,1,91,16.492a.733.733,0,0,1,0-.139l1.688-4.219a20.788,20.788,0,0,0,1.291-4.6l.844-5.043a1.006,1.006,0,1,1,1.986.328l-.794,5.033a23.27,23.27,0,0,1-1.41,5.063l-1.618,4.11a10.752,10.752,0,0,0-.3,2.522v.774A10.7,10.7,0,0,0,94.6,26.439a27.211,27.211,0,0,1,3.346,7.019,26.537,26.537,0,0,1,1.727,7.168A.993.993,0,0,1,98.682,41.618Z",
    transform: "translate(-5.232 -0.558)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117801",
    "data-name": "Path 117801",
    d: "M60.493,41.619a.993.993,0,0,1-.993-.993,26.536,26.536,0,0,1,1.727-7.168,27.45,27.45,0,0,1,3.385-7.029,9.8,9.8,0,0,0,.913-1.588l.993-4.05V19.55a10.751,10.751,0,0,0-.3-2.522l-1.648-4.11a23.588,23.588,0,0,1-1.41-4.964l-.844-5.033A1.006,1.006,0,0,1,64.3,2.594l.844,5.033a20.49,20.49,0,0,0,1.291,4.6l1.688,4.229a.734.734,0,0,1,0,.139,12.637,12.637,0,0,1,.367,3.058v1.459a.993.993,0,0,1,0,.169L67.452,25.5a.755.755,0,0,1-.06.159,10.781,10.781,0,0,1-1.142,1.986,25.633,25.633,0,0,0-3.127,6.522c-1.34,3.971-1.618,5.728-1.618,6.522a.993.993,0,0,1-1.013.933Z",
    transform: "translate(-5.006 -0.559)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5289",
    "data-name": "Rectangle 5289",
    width: 4.219,
    height: 11.248,
    transform: "translate(73.595 23.757)",
    fill: "#c2470d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5290",
    "data-name": "Rectangle 5290",
    width: 4.219,
    height: 7.029,
    transform: "translate(73.595 27.966)",
    fill: "#d84f10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117802",
    "data-name": "Path 117802",
    d: "M82.867,24.449H65.99V20.23H80.057Z",
    transform: "translate(-5.053 -0.693)",
    fill: "#d84f10"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5291",
    "data-name": "Rectangle 5291",
    width: 8.438,
    height: 4.219,
    transform: "translate(79.561 19.537)",
    fill: "#d84f10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117803",
    "data-name": "Path 117803",
    d: "M81.139,22.335H65.99v-2.1H80.057Z",
    transform: "translate(-5.053 -0.693)",
    fill: "#dc6127"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5292",
    "data-name": "Rectangle 5292",
    width: 8.438,
    height: 2.154,
    transform: "translate(79.561 19.537)",
    fill: "#dc6127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117804",
    "data-name": "Path 117804",
    d: "M82.87,25.435H65.993A.993.993,0,0,1,65,24.442V20.223a.993.993,0,0,1,.993-.993H80.05a.993.993,0,0,1,.824.437l2.81,4.219a1.009,1.009,0,0,1-.814,1.549ZM66.986,23.449H81l-1.489-2.234H66.986Z",
    transform: "translate(-5.046 -0.685)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117805",
    "data-name": "Path 117805",
    d: "M82.962,36.713H78.733a.993.993,0,0,1-.993-.993V24.473a.993.993,0,0,1,.993-.993h4.229a.993.993,0,0,1,.993.993V35.721A.993.993,0,0,1,82.962,36.713Zm-3.226-1.986h2.234V25.466H79.726Z",
    transform: "translate(-5.138 -0.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117806",
    "data-name": "Path 117806",
    d: "M70.233,25.455a.993.993,0,0,1-.993-.993v-1.41a.993.993,0,0,1,1.986,0v1.41A.993.993,0,0,1,70.233,25.455Z",
    transform: "translate(-5.076 -0.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117807",
    "data-name": "Path 117807",
    d: "M74.483,25.455a.993.993,0,0,1-.993-.993v-1.41a.993.993,0,1,1,1.986,0v1.41A.993.993,0,0,1,74.483,25.455Z",
    transform: "translate(-5.107 -0.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117808",
    "data-name": "Path 117808",
    d: "M78.733,25.455a.993.993,0,0,1-.993-.993v-1.41a.993.993,0,1,1,1.986,0v1.41A.993.993,0,0,1,78.733,25.455Z",
    transform: "translate(-5.138 -0.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117809",
    "data-name": "Path 117809",
    d: "M80.142,29.706h-1.41a.993.993,0,1,1,0-1.986h1.41a.993.993,0,1,1,0,1.986Z",
    transform: "translate(-5.138 -0.747)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117810",
    "data-name": "Path 117810",
    d: "M80.142,33.986h-1.41a.993.993,0,1,1,0-1.986h1.41a.993.993,0,1,1,0,1.986Z",
    transform: "translate(-5.138 -0.778)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117811",
    "data-name": "Path 117811",
    d: "M93.181,25.435H84.743a.993.993,0,0,1-.993-.993V20.223a.993.993,0,0,1,.993-.993h8.438a.993.993,0,0,1,.993.993v4.219A.993.993,0,0,1,93.181,25.435Zm-7.446-1.986h6.453V21.216H85.736Z",
    transform: "translate(-5.181 -0.685)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117812",
    "data-name": "Path 117812",
    d: "M88.993,25.455A.993.993,0,0,1,88,24.462v-1.41a.993.993,0,1,1,1.986,0v1.41A.993.993,0,0,1,88.993,25.455Z",
    transform: "translate(-5.212 -0.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117813",
    "data-name": "Path 117813",
    d: "M72.453,18a1.1,1.1,0,0,1-.486-.119.993.993,0,0,1-.377-1.35c.109-.208,2.81-4.964,7.1-4.964a.993.993,0,1,1,0,1.986c-3.117,0-5.341,3.892-5.361,3.921A.993.993,0,0,1,72.453,18Z",
    transform: "translate(-5.092 -0.63)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5293",
    "data-name": "Rectangle 5293",
    width: 37.963,
    height: 3.594,
    transform: "translate(55.487 37.894)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117814",
    "data-name": "Path 117814",
    d: "M98.456,43.3H60.493a.993.993,0,0,1-.993-.993V38.713a.993.993,0,0,1,.993-.993H98.456a.993.993,0,0,1,.993.993v3.594A.993.993,0,0,1,98.456,43.3Zm-36.97-1.986H97.463V39.706H61.486Z",
    transform: "translate(-5.006 -0.819)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10032",
    "data-name": "Ellipse 10032",
    cx: 11.427,
    cy: 11.427,
    r: 11.427,
    transform: "translate(56.986 48.01)",
    fill: "#e69bb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117815",
    "data-name": "Path 117815",
    d: "M82.972,54.07a11.427,11.427,0,0,1-20.232,10.3,11.427,11.427,0,1,0,20.232-10.3Z",
    transform: "translate(-5.029 -0.938)",
    fill: "#cf8c9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117816",
    "data-name": "Path 117816",
    d: "M73.422,48.9a11.427,11.427,0,1,1-10.871,7.942A11.427,11.427,0,0,1,73.422,48.9m0-1.986h0a13.412,13.412,0,1,0,4.15.655A13.412,13.412,0,0,0,73.422,46.91Z",
    transform: "translate(-5.009 -0.886)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117817",
    "data-name": "Path 117817",
    d: "M71.163,58.206a1.092,1.092,0,0,1-.308,0,.993.993,0,0,1-.635-1.261l.417-1.3a1,1,0,1,1,1.9.606l-.427,1.3A.993.993,0,0,1,71.163,58.206Z",
    transform: "translate(-5.083 -0.944)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117818",
    "data-name": "Path 117818",
    d: "M77.293,60.206a1.112,1.112,0,0,1-.308,0,.993.993,0,0,1-.635-1.251l.417-1.31a.976.976,0,1,1,1.856.606l-.427,1.31A.993.993,0,0,1,77.293,60.206Z",
    transform: "translate(-5.127 -0.959)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117819",
    "data-name": "Path 117819",
    d: "M75.207,67.03a1.112,1.112,0,0,1-.258-.06l-6.413-2.085A.993.993,0,0,1,69.1,63l6.413,2.085a1,1,0,1,1-.308,1.986Z",
    transform: "translate(-5.067 -1.002)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10033",
    "data-name": "Ellipse 10033",
    cx: 11.427,
    cy: 11.427,
    r: 11.427,
    transform: "translate(300.162 22.814)",
    fill: "#adbbd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117820",
    "data-name": "Path 117820",
    d: "M321.833,24.05a11.427,11.427,0,0,1-9.183,20.8,11.427,11.427,0,1,0,9.183-20.768Z",
    transform: "translate(-6.839 -0.72)",
    fill: "#92a1b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117821",
    "data-name": "Path 117821",
    d: "M318.362,23.506a11.437,11.437,0,1,1-4.12.774,11.437,11.437,0,0,1,4.12-.774m0-1.986h0A13.412,13.412,0,1,0,330.881,30.1a13.412,13.412,0,0,0-12.519-8.577Z",
    transform: "translate(-6.783 -0.702)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117822",
    "data-name": "Path 117822",
    d: "M314.619,35.027a.993.993,0,0,1-.923-.635l-.5-1.281a.993.993,0,0,1,1.847-.715l.5,1.281a.993.993,0,0,1-.556,1.3A.913.913,0,0,1,314.619,35.027Z",
    transform: "translate(-6.843 -0.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117823",
    "data-name": "Path 117823",
    d: "M320.629,32.706a.993.993,0,0,1-.923-.635l-.5-1.281a.995.995,0,0,1,1.856-.715l.486,1.281a.993.993,0,0,1-.566,1.281A1.141,1.141,0,0,1,320.629,32.706Z",
    transform: "translate(-6.886 -0.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117824",
    "data-name": "Path 117824",
    d: "M315.7,42.23a.969.969,0,0,1-.7-1.668l.238-.238a11.983,11.983,0,0,1,9.451-3.495,1,1,0,0,1-.149,1.986,10.017,10.017,0,0,0-7.942,2.978l-.238.238a.993.993,0,0,1-.655.2Z",
    transform: "translate(-6.854 -0.812)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10034",
    "data-name": "Ellipse 10034",
    cx: 11.427,
    cy: 11.427,
    r: 11.427,
    transform: "translate(265.088 2.512)",
    fill: "#f6c354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117825",
    "data-name": "Path 117825",
    d: "M292.375,7.92A11.427,11.427,0,0,1,272.52,18.91,11.427,11.427,0,1,0,292.375,7.92Z",
    transform: "translate(-6.548 -0.603)",
    fill: "#dca93b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117826",
    "data-name": "Path 117826",
    d: "M284.8,20.625a11.913,11.913,0,0,1-7.942-3.038.993.993,0,1,1,1.31-1.489,10.017,10.017,0,0,0,8.071,2.442h.328a1,1,0,1,1,.268,1.986H286.5a11.785,11.785,0,0,1-1.7.1Z",
    transform: "translate(-6.577 -0.661)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117827",
    "data-name": "Path 117827",
    d: "M283.042,3.066a11.6,11.6,0,0,1,3.157.447,11.427,11.427,0,0,1-3.147,22.416,11.725,11.725,0,0,1-3.167-.447,11.427,11.427,0,0,1,3.157-22.416m0-1.986h0a13.442,13.442,0,1,0,3.713.526,13.442,13.442,0,0,0-3.713-.526Z",
    transform: "translate(-6.527 -0.554)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117828",
    "data-name": "Path 117828",
    d: "M280.673,12.466a.834.834,0,0,1-.268,0,.993.993,0,0,1-.685-1.231l.377-1.31a.991.991,0,1,1,1.906.546l-.377,1.32A.993.993,0,0,1,280.673,12.466Z",
    transform: "translate(-6.6 -0.613)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117829",
    "data-name": "Path 117829",
    d: "M286.873,14.246a.893.893,0,0,1-.278,0,.993.993,0,0,1-.675-1.221l.377-1.32a.993.993,0,1,1,1.906.546l-.377,1.32a.993.993,0,0,1-.953.675Z",
    transform: "translate(-6.645 -0.625)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10035",
    "data-name": "Ellipse 10035",
    cx: 11.427,
    cy: 11.427,
    r: 11.427,
    transform: "translate(109.85 71.081)",
    fill: "#f6c354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117830",
    "data-name": "Path 117830",
    d: "M128.871,72.35a11.427,11.427,0,0,1-6.741,21.682,11.427,11.427,0,1,0,6.741-21.682Z",
    transform: "translate(-5.459 -1.07)",
    fill: "#dca93b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117831",
    "data-name": "Path 117831",
    d: "M122.308,88.458a.4.4,0,0,0-.109.625A6.761,6.761,0,0,0,133.785,83a.4.4,0,0,0-.576-.268Z",
    transform: "translate(-5.459 -1.145)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117832",
    "data-name": "Path 117832",
    d: "M126.662,72.126a11.437,11.437,0,1,1-5.311,1.32,11.437,11.437,0,0,1,5.311-1.32m0-1.986h0A13.412,13.412,0,1,0,137.473,75.6a13.422,13.422,0,0,0-10.811-5.459Z",
    transform: "translate(-5.395 -1.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117833",
    "data-name": "Path 117833",
    d: "M120.993,84.884h-.079A.993.993,0,0,1,120,83.842a2.859,2.859,0,0,1,1.191-2.124,2.78,2.78,0,0,1,2.651,0,.993.993,0,1,1-.754,1.837c-.457-.189-.735-.189-.844-.119a.834.834,0,0,0-.258.546A.993.993,0,0,1,120.993,84.884Z",
    transform: "translate(-5.444 -1.135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117834",
    "data-name": "Path 117834",
    d: "M127.763,81.335h-.079a.993.993,0,0,1-.913-.993,2.859,2.859,0,0,1,1.191-2.125,2.78,2.78,0,0,1,2.651,0,.993.993,0,1,1-.755,1.837c-.457-.189-.735-.189-.844-.119a.854.854,0,0,0-.258.576.993.993,0,0,1-.993.824Z",
    transform: "translate(-5.493 -1.11)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10036",
    "data-name": "Ellipse 10036",
    cx: 6.949,
    cy: 6.949,
    r: 6.949,
    transform: "translate(192.359 81.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10037",
    "data-name": "Ellipse 10037",
    cx: 6.949,
    cy: 6.949,
    r: 6.949,
    transform: "translate(221.297 81.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117835",
    "data-name": "Path 117835",
    d: "M236.466,94.741a.486.486,0,0,1-.467-.318.5.5,0,0,1,.288-.645,4.964,4.964,0,0,0,2.889-6.393.5.5,0,1,1,.923-.347,5.957,5.957,0,0,1-3.465,7.674Z",
    transform: "translate(-6.284 -1.174)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117836",
    "data-name": "Path 117836",
    d: "M229.374,91.541a.486.486,0,0,1-.467-.318,5.957,5.957,0,0,1,3.465-7.684.5.5,0,0,1,.347.933,4.964,4.964,0,0,0-2.889,6.393.5.5,0,0,1-.288.645A.466.466,0,0,1,229.374,91.541Z",
    transform: "translate(-6.23 -1.151)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117837",
    "data-name": "Path 117837",
    d: "M237.754,88.4a.477.477,0,0,1-.457-.318,2.978,2.978,0,0,0-3.842-1.737.486.486,0,0,1-.635-.288.5.5,0,0,1,.288-.645,3.971,3.971,0,0,1,5.113,2.313.5.5,0,0,1-.288.645.566.566,0,0,1-.179.03Z",
    transform: "translate(-6.261 -1.163)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117838",
    "data-name": "Path 117838",
    d: "M234.493,93.136a3.971,3.971,0,0,1-3.713-2.571.5.5,0,1,1,.923-.347,2.978,2.978,0,0,0,1.569,1.658,2.919,2.919,0,0,0,2.273.069.5.5,0,0,1,.645.288.516.516,0,0,1-.288.645,4.149,4.149,0,0,1-1.41.258Z",
    transform: "translate(-6.246 -1.197)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117839",
    "data-name": "Path 117839",
    d: "M199.866,89.613a.5.5,0,0,1-.5-.5,5.957,5.957,0,0,1,5.957-5.957.5.5,0,0,1,.5.5.506.506,0,0,1-.5.5,4.964,4.964,0,0,0-4.964,4.964.506.506,0,0,1-.5.5Z",
    transform: "translate(-6.019 -1.148)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117840",
    "data-name": "Path 117840",
    d: "M205.366,95.113a.5.5,0,0,1,0-.993,4.964,4.964,0,0,0,4.964-4.964.5.5,0,1,1,.993,0A5.957,5.957,0,0,1,205.366,95.113Z",
    transform: "translate(-6.059 -1.188)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117841",
    "data-name": "Path 117841",
    d: "M205.341,93.127a3.971,3.971,0,0,1-3.971-3.971.5.5,0,1,1,.993,0,2.978,2.978,0,0,0,2.978,2.978.5.5,0,0,1,.5.5A.506.506,0,0,1,205.341,93.127Z",
    transform: "translate(-6.033 -1.188)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117842",
    "data-name": "Path 117842",
    d: "M208.841,89.627a.5.5,0,0,1-.5-.5,2.978,2.978,0,0,0-2.978-2.978.5.5,0,0,1,0-.993,3.971,3.971,0,0,1,3.971,3.971.506.506,0,0,1-.5.5Z",
    transform: "translate(-6.059 -1.163)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117843",
    "data-name": "Path 117843",
    d: "M205.3,82.146a6.949,6.949,0,1,1-6.949,6.949,6.949,6.949,0,0,1,6.949-6.949m0-1.986a8.935,8.935,0,1,0,8.935,8.935A8.935,8.935,0,0,0,205.3,80.16Z",
    transform: "translate(-5.997 -1.127)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10038",
    "data-name": "Ellipse 10038",
    cx: 1.986,
    cy: 1.986,
    rx: 1.986,
    ry: 1.986,
    transform: "translate(197.322 85.983)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117844",
    "data-name": "Path 117844",
    d: "M234.455,82.146a6.949,6.949,0,1,1-6.949,6.949,6.949,6.949,0,0,1,6.949-6.949m0-1.986a8.935,8.935,0,1,0,8.935,8.935A8.935,8.935,0,0,0,234.455,80.16Z",
    transform: "translate(-6.208 -1.127)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10039",
    "data-name": "Ellipse 10039",
    cx: 1.986,
    cy: 1.986,
    rx: 1.986,
    ry: 1.986,
    transform: "translate(226.261 85.983)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117845",
    "data-name": "Path 117845",
    d: "M212.511,90.061h-7.148a.992.992,0,0,1-.923-1.36l4.616-11.615a.994.994,0,1,1,1.847.735l-4.08,10.255h5.688a.993.993,0,1,1,0,1.986Z",
    transform: "translate(-6.055 -1.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117846",
    "data-name": "Path 117846",
    d: "M234.439,90.016a.993.993,0,0,1-.516-.159L223.857,83.6a.994.994,0,0,1,1.052-1.688l8.111,5.043L229.952,71.5a1.012,1.012,0,0,1,1.986-.4l3.475,17.76a.956.956,0,0,1-.973,1.152Z",
    transform: "translate(-6.193 -1.055)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117847",
    "data-name": "Path 117847",
    d: "M213.081,79.484a.993.993,0,0,1-.457-.109L206.906,76.4a.995.995,0,1,1,.913-1.767l5.718,2.978a1,1,0,0,1-.457,1.876Z",
    transform: "translate(-6.069 -1.086)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117848",
    "data-name": "Path 117848",
    d: "M221.974,63.875a3.5,3.5,0,0,1,2.373.933,2.462,2.462,0,0,1,.715.993,3.226,3.226,0,0,1,.328.993l.993,3.117,5.54-2.194a2.452,2.452,0,0,1,.913-.179,2.482,2.482,0,0,1,.913,4.785l-8.031,3.2a2.442,2.442,0,0,1-.913.169,2.522,2.522,0,0,1-1.072-.238,2.482,2.482,0,0,1-1.3-1.509l-.606-1.986-2.571,1.986,4.726,2.353a2.5,2.5,0,0,1,1.261,1.469,2.462,2.462,0,0,1-.189,1.926L219.9,89.26a2.472,2.472,0,0,1-2.184,1.31,2.542,2.542,0,0,1-1.181-.3,2.482,2.482,0,0,1-.993-3.365l3.971-7.317s-7.386-3.336-7.942-4.12a3.465,3.465,0,0,1,.655-4.865L220,64.65a3.435,3.435,0,0,1,2.085-.7m0-1.986a5.43,5.43,0,0,0-3.405,1.032l-7.763,5.957a5.45,5.45,0,0,0-1.042,7.644c.268.357.794.993,6.8,3.842l-2.929,5.391a4.477,4.477,0,0,0,1.807,6.056,4.557,4.557,0,0,0,2.125.536,4.467,4.467,0,0,0,3.971-2.353l5.152-9.57a4.467,4.467,0,0,0,.328-3.475h0l7.366-2.978a4.467,4.467,0,1,0-3.3-8.3l-3.534,1.4-.3-.993a5.769,5.769,0,0,0-.457-1.3,4.487,4.487,0,0,0-1.2-1.578,5.44,5.44,0,0,0-3.683-1.43Z",
    transform: "translate(-6.087 -0.994)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117849",
    "data-name": "Path 117849",
    d: "M235.113,69.022a2.472,2.472,0,0,0-3.217-1.39l-5.54,2.194-.993-3.117a3.227,3.227,0,0,0-.328-.993,2.462,2.462,0,0,0-.715-.993,3.455,3.455,0,0,0-4.388-.129l-7.773,5.957a3.465,3.465,0,0,0-.655,4.865c.586.784,7.942,4.12,7.942,4.12l-3.971,7.317a2.482,2.482,0,0,0,.993,3.365,2.542,2.542,0,0,0,1.181.3,2.472,2.472,0,0,0,2.184-1.31l5.152-9.57a2.462,2.462,0,0,0,.189-1.926,2.5,2.5,0,0,0-1.261-1.469l-4.726-2.353L221.76,71.9l.606,1.986a2.482,2.482,0,0,0,3.286,1.578l8.031-3.2a2.472,2.472,0,0,0,1.43-3.246Z",
    transform: "translate(-6.101 -1.009)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117850",
    "data-name": "Path 117850",
    d: "M231.957,67.633l-5.54,2.194-.993-3.117a3.226,3.226,0,0,0-.328-.993,2.462,2.462,0,0,0-.715-.993,3.455,3.455,0,0,0-4.388-.129l-.745.566c.864,0,1.638.139,1.986.844.824,1.926,3.733,7.158,3.733,7.158l10.146-4.4a2.462,2.462,0,0,0-3.157-1.132Z",
    transform: "translate(-6.163 -1.009)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117851",
    "data-name": "Path 117851",
    d: "M212.13,70.547a3.465,3.465,0,0,0-.655,4.865c.586.784,7.942,4.12,7.942,4.12l-3.971,7.317a2.482,2.482,0,0,0,.993,3.365,2.541,2.541,0,0,0,1.181.3A2.472,2.472,0,0,0,219.8,89.2l5.152-9.57a2.462,2.462,0,0,0,.189-1.926,2.5,2.5,0,0,0-1.261-1.469l-4.726-2.353-6.473-3.8Z",
    transform: "translate(-6.101 -1.054)",
    fill: "#dc6127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117852",
    "data-name": "Path 117852",
    d: "M214.413,75.137a5.817,5.817,0,0,1-3.346-3.207,3.455,3.455,0,0,0,.407,3.494c.586.784,7.942,4.12,7.942,4.12l-3.971,7.317a2.482,2.482,0,0,0,.993,3.365l5.579-11.754A73.772,73.772,0,0,0,214.413,75.137Z",
    transform: "translate(-6.101 -1.067)",
    fill: "#c2470d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10040",
    "data-name": "Ellipse 10040",
    cx: 4.09,
    cy: 4.09,
    rx: 4.09,
    ry: 4.09,
    transform: "translate(219.272 55.346)",
    fill: "#f6c354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117853",
    "data-name": "Path 117853",
    d: "M229.566,56.286a4.1,4.1,0,1,1-3.475,1.916,4.1,4.1,0,0,1,3.475-1.916m0-1.986h0a6.076,6.076,0,1,0,3.217.923A6.076,6.076,0,0,0,229.566,54.3Z",
    transform: "translate(-6.193 -0.939)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117854",
    "data-name": "Path 117854",
    d: "M227.6,56.812l6.036,3.782a4.329,4.329,0,0,1-.179,1.052l-6.721-4.2a4.4,4.4,0,0,1,.864-.635m0-1.152-.516.288a4.774,4.774,0,0,0-1.062.774l-.943.874,1.092.685,6.771,4.209,1.092.685.377-1.241a5.183,5.183,0,0,0,.228-1.291v-.586l-.5-.308L228.128,56l-.486-.308Z",
    transform: "translate(-6.205 -0.949)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117855",
    "data-name": "Path 117855",
    d: "M233.471,61.655a4.329,4.329,0,0,0,.179-1.052l-6.036-3.782a4.4,4.4,0,0,0-.864.635Z",
    transform: "translate(-6.217 -0.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117856",
    "data-name": "Path 117856",
    d: "M206.889,62.806h-5.957a.993.993,0,0,1,0-1.986h5.957a.993.993,0,0,1,0,1.986Z",
    transform: "translate(-6.023 -0.987)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117857",
    "data-name": "Path 117857",
    d: "M215.911,62.806h-2.978a.993.993,0,0,1,0-1.986h2.978a.993.993,0,1,1,0,1.986Z",
    transform: "translate(-6.11 -0.987)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117858",
    "data-name": "Path 117858",
    d: "M202.9,76.146h-3.971a.993.993,0,1,1,0-1.986H202.9a.993.993,0,0,1,0,1.986Z",
    transform: "translate(-6.008 -1.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117859",
    "data-name": "Path 117859",
    d: "M205.882,69.476h-6.949a.993.993,0,1,1,0-1.986h6.949a.993.993,0,1,1,0,1.986Z",
    transform: "translate(-6.008 -1.035)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117860",
    "data-name": "Path 117860",
    d: "M218.846,56.146H206.933a.993.993,0,0,1,0-1.986h11.913a.993.993,0,1,1,0,1.986Z",
    transform: "translate(-6.066 -0.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117861",
    "data-name": "Path 117861",
    d: "M220.928,74.6a1.1,1.1,0,0,1-.457-.109c-2.661-1.39-8.786-3.8-8.845-3.822a.993.993,0,0,1,.725-1.847c.258.1,6.284,2.472,9.044,3.9a.993.993,0,0,1-.467,1.876Z",
    transform: "translate(-6.103 -1.044)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117862",
    "data-name": "Path 117862",
    d: "M36,35.713l1.866,3.594v.079a5.341,5.341,0,0,0,1.211,1.837L44.141,46.3A2.734,2.734,0,1,0,48,42.424l-4.269-4.269a5.2,5.2,0,0,1-1.211-1.837L41.3,34.105,39.425,30.7Z",
    transform: "translate(-4.835 -0.768)",
    fill: "#d84f10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117863",
    "data-name": "Path 117863",
    d: "M35.96,35.713l1.866,3.594,3.475-5.2L39.425,30.7Z",
    transform: "translate(-4.835 -0.768)",
    fill: "#c2470d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117864",
    "data-name": "Path 117864",
    d: "M39.411,30.7l3.1,5.609a5.341,5.341,0,0,0,1.211,1.837l4.269,4.269a2.734,2.734,0,0,1-3.862,3.872l-5.063-5.073a5.48,5.48,0,0,1-1.211-1.837L35.986,35.7l3.465-4.964m0-1.986a1.986,1.986,0,0,0-1.628.854l-3.465,4.964a1.986,1.986,0,0,0-.129,2.035l1.856,3.6a7.535,7.535,0,0,0,1.618,2.4l5.063,5.063a4.716,4.716,0,0,0,6.622-6.661l-4.259-4.269a3.355,3.355,0,0,1-.774-1.162,1.618,1.618,0,0,0-.109-.228l-3.1-5.619a1.986,1.986,0,0,0-1.638-.993Z",
    transform: "translate(-4.821 -0.754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117865",
    "data-name": "Path 117865",
    d: "M21.668,27.9a2.69,2.69,0,0,0,3.624,1.211l1.986-.993a5.46,5.46,0,0,0,2.71-3.2l.467-1.41,1.469,5.818h0l-3.882,4.239a5.381,5.381,0,0,0-1.271,2.363l-1.9,7.644a2.732,2.732,0,1,0,5.3,1.32l1.559-6.254a5.43,5.43,0,0,1,1.271-2.363L38.118,30.7a5.49,5.49,0,0,0,1.271-5.013l-.169-.665L38.088,20.5l2.293.923a2.73,2.73,0,0,1,1.4,1.31l.576,1.191A2.69,2.69,0,0,0,45.98,25.15a2.74,2.74,0,0,0,1.211-3.663l-.566-1.162a8.19,8.19,0,0,0-4.249-3.971c-3.187-1.291-4.884-2.154-7.942-2.144a9.312,9.312,0,0,0-8.726,6.473l-.824,2.512-1.986.993A2.77,2.77,0,0,0,21.668,27.9Z",
    transform: "translate(-4.73 -0.649)",
    fill: "#dc6127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117866",
    "data-name": "Path 117866",
    d: "M21.668,27.9a2.69,2.69,0,0,0,3.624,1.211l1.986-.993a5.46,5.46,0,0,0,2.71-3.2l.467-1.41,1.469,5.818L36,26.907l3.217-1.9-1.132-4.517,2.293.923a2.73,2.73,0,0,1,1.4,1.31l.576,1.2A2.69,2.69,0,0,0,45.98,25.15a2.74,2.74,0,0,0,1.211-3.663l-.566-1.162a8.19,8.19,0,0,0-4.249-3.971c-3.187-1.291-4.884-2.154-7.942-2.144a8.845,8.845,0,0,0-4.666,1.34,9.511,9.511,0,0,0-4.06,5.133l-.824,2.512-1.986.993A2.77,2.77,0,0,0,21.668,27.9Z",
    transform: "translate(-4.73 -0.649)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117867",
    "data-name": "Path 117867",
    d: "M21.668,27.91a2.69,2.69,0,0,0,3.624,1.211l1.986-.993a5.46,5.46,0,0,0,2.71-3.2l.467-1.41,1.469,5.818L36,26.917c-3.971-1.4-5.708-8.567-6.244-11.367a9.511,9.511,0,0,0-4.06,5.133l-.824,2.512-1.986.993A2.77,2.77,0,0,0,21.668,27.91Z",
    transform: "translate(-4.73 -0.659)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117868",
    "data-name": "Path 117868",
    d: "M34.46,14.2c3.038,0,4.735.864,7.942,2.144a8.21,8.21,0,0,1,4.239,3.971l.566,1.162A2.74,2.74,0,0,1,46,25.136a2.611,2.611,0,0,1-1.2.288,2.71,2.71,0,0,1-2.452-1.509l-.566-1.162a2.75,2.75,0,0,0-1.41-1.31l-2.293-.923,1.3,5.182A5.46,5.46,0,0,1,38.1,30.715l-5.113,5.579a5.54,5.54,0,0,0-1.271,2.363l-1.559,6.254a2.73,2.73,0,0,1-2.651,2.065,2.462,2.462,0,0,1-.655-.079,2.73,2.73,0,0,1-1.986-3.306L26.766,36a5.381,5.381,0,0,1,1.271-2.363l3.872-4.269-1.668-6.949s-.794,3.872-2.075,4.517l-2.889,2.1a2.611,2.611,0,0,1-1.2.288,2.7,2.7,0,0,1-2.422-1.44,2.77,2.77,0,0,1,1.221-3.673l1.986-.993.834-2.512a9.292,9.292,0,0,1,8.716-6.473h0m0-1.986h-.06a11.238,11.238,0,0,0-10.543,7.793l-.576,1.727-1.251.645a4.735,4.735,0,0,0-2.1,6.314,4.656,4.656,0,0,0,4.2,2.611,4.716,4.716,0,0,0,2.1-.5l.268-.169,2.8-2.045a3.256,3.256,0,0,0,.377-.268l.109.437-3.167,3.465A7.366,7.366,0,0,0,24.83,35.48l-1.856,7.595a4.656,4.656,0,0,0,.536,3.574,4.706,4.706,0,0,0,2.9,2.144,4.438,4.438,0,0,0,1.142.139,4.716,4.716,0,0,0,4.577-3.564L33.686,39.1a3.524,3.524,0,0,1,.814-1.5l5.113-5.579A7.466,7.466,0,0,0,41.5,26.009a4.7,4.7,0,0,0,7.515-5.44l-.576-1.162a10.067,10.067,0,0,0-5.281-4.9l-1.072-.437c-2.621-1.082-4.507-1.856-7.575-1.856Z",
    transform: "translate(-4.715 -0.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117869",
    "data-name": "Path 117869",
    d: "M30.993,29.9a.993.993,0,0,1-.526-1.837,36.1,36.1,0,0,1,9-3.822,1,1,0,1,1,.506,1.926,34.826,34.826,0,0,0-8.458,3.574A.933.933,0,0,1,30.993,29.9Z",
    transform: "translate(-4.792 -0.721)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10041",
    "data-name": "Ellipse 10041",
    cx: 4.1,
    cy: 4.1,
    rx: 4.1,
    ry: 4.1,
    transform: "translate(22.12 2.631)",
    fill: "#f6c354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117870",
    "data-name": "Path 117870",
    d: "M30.956,3.2a2.978,2.978,0,0,1,.417,0,4.1,4.1,0,1,1-.417,8.19h-.417a4.1,4.1,0,0,1,.417-8.19m0-1.986a6.086,6.086,0,0,0-.606,12.131h.616A6.086,6.086,0,0,0,31.572,1.21Z",
    transform: "translate(-4.755 -0.555)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117871",
    "data-name": "Path 117871",
    d: "M27.636,4.992l7.088.715a4.11,4.11,0,0,1,.3.993L27.14,5.905a4.328,4.328,0,0,1,.5-.993M27.16,3.87l-.328.477a4.835,4.835,0,0,0-.616,1.162L25.76,6.779l1.281.129,7.882.794,1.281.129-.2-1.271a5.172,5.172,0,0,0-.367-1.271L35.4,4.763l-.576-.06L27.736,4l-.576-.06Z",
    transform: "translate(-4.761 -0.574)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117872",
    "data-name": "Path 117872",
    d: "M27.15,5.933a4.328,4.328,0,0,1,.5-.993l7.088.715a4.11,4.11,0,0,1,.3.993Z",
    transform: "translate(-4.771 -0.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117873",
    "data-name": "Path 117873",
    d: "M246.145,47.393a12.409,12.409,0,0,1-11.5-7.714l-2.819-6.949a.993.993,0,1,1,1.837-.754l2.819,6.949A10.4,10.4,0,0,0,255.765,31.1L253.68,25.99a.993.993,0,1,1,1.837-.745l2.085,5.133a12.38,12.38,0,0,1-11.456,17.056Z",
    transform: "translate(-6.253 -0.724)",
    fill: "#176fa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117874",
    "data-name": "Path 117874",
    d: "M254.579,24.616a.993.993,0,0,1,.884.6l2.085,5.123a12.36,12.36,0,0,1-6.781,16.093,12.131,12.131,0,0,1-4.636.913,12.379,12.379,0,0,1-11.456-7.692l-2.82-6.951a.993.993,0,0,1,.516-1.241.913.913,0,0,1,.357-.069.993.993,0,0,1,.884.6l2.819,6.949a10.46,10.46,0,1,0,19.379-7.882l-2.1-5.073a.993.993,0,0,1,.516-1.241.913.913,0,0,1,.357-.069m0-1.986a2.8,2.8,0,0,0-1.1.218,2.978,2.978,0,0,0-1.638,3.772l2.095,5.133a8.463,8.463,0,0,1-15.676,6.383l-2.829-6.949A2.932,2.932,0,0,0,230,33.451l2.829,6.949a14.336,14.336,0,0,0,26.556-10.811L257.3,24.457a2.919,2.919,0,0,0-2.72-1.827Z",
    transform: "translate(-6.239 -0.71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117875",
    "data-name": "Path 117875",
    d: "M233.17,7.456a.993.993,0,0,1,.874.6l3.584,8.8a10.454,10.454,0,0,1-19.359,7.882l-3.574-8.806a.993.993,0,0,1,.516-1.231l4.4-1.747a1.142,1.142,0,0,1,.357-.069.993.993,0,0,1,.367,1.837l-3.524,1.43,3.226,7.942a8.568,8.568,0,0,0,7.942,5.321,8.369,8.369,0,0,0,3.217-.635,8.558,8.558,0,0,0,4.636-11.208L232.6,9.62l-3.514,1.43a.913.913,0,0,1-.357.069.948.948,0,0,1-.357-1.827l4.477-1.767a.913.913,0,0,1,.357-.069m0-1.986a3.038,3.038,0,0,0-1.112.218l-4.4,1.787a2.978,2.978,0,0,0-1.608,3.832,2.919,2.919,0,0,0,2.72,1.827,2.8,2.8,0,0,0,1.062-.189l1.678-.685,2.482,6.086a6.572,6.572,0,0,1-3.614,8.5,6.364,6.364,0,0,1-2.462.486,6.552,6.552,0,0,1-6.086-4.09L219.4,17.165l1.678-.685a2.978,2.978,0,0,0,1.6-1.549,2.889,2.889,0,0,0,0-2.244,2.93,2.93,0,0,0-3.832-1.628l-4.4,1.787a2.978,2.978,0,0,0-1.618,3.832l3.584,8.8A12.433,12.433,0,0,0,239.444,16.1L235.87,7.3a2.978,2.978,0,0,0-2.72-1.827Z",
    transform: "translate(-6.115 -0.586)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117876",
    "data-name": "Path 117876",
    d: "M253.141,16.916a4.735,4.735,0,1,1-1.8.347,4.735,4.735,0,0,1,1.8-.347m0-1.986h0a6.731,6.731,0,1,0,6.7,6.085,6.771,6.771,0,0,0-6.7-6.085Z",
    transform: "translate(-6.359 -0.654)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10042",
    "data-name": "Ellipse 10042",
    cx: 4.745,
    cy: 4.745,
    rx: 4.745,
    ry: 4.745,
    transform: "translate(242.036 16.261)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10043",
    "data-name": "Ellipse 10043",
    cx: 2.849,
    cy: 2.849,
    rx: 2.849,
    ry: 2.849,
    transform: "translate(243.932 18.158)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117877",
    "data-name": "Path 117877",
    d: "M231.874,30.482a10.474,10.474,0,0,1-13.621-5.738l-3.544-8.806a.993.993,0,0,1,.516-1.231l4.4-1.747a.993.993,0,0,1,.725,1.767l-3.524,1.43,3.226,7.942a8.548,8.548,0,0,0,15.795-6.522l-3.227-7.942-3.514,1.43a.949.949,0,1,1-.715-1.757l4.477-1.767a.993.993,0,0,1,1.231.526l3.584,8.8a10.454,10.454,0,0,1-5.808,13.621Z",
    transform: "translate(-6.129 -0.6)",
    fill: "#cfcfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117878",
    "data-name": "Path 117878",
    d: "M228,10.576a.993.993,0,0,0,1.241.526l1.737-.715-.715-1.757-1.757.715A.993.993,0,0,0,228,10.576Z",
    transform: "translate(-6.226 -0.609)",
    fill: "#186fa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117879",
    "data-name": "Path 117879",
    d: "M218.6,15.432l1.767-.715a.993.993,0,0,0-.725-1.767l-1.757.715Z",
    transform: "translate(-6.153 -0.64)",
    fill: "#186fa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117880",
    "data-name": "Path 117880",
    d: "M230.275,8.623l.695,1.757-1.757.715a.913.913,0,0,1-.357.069.948.948,0,0,1-.357-1.827l1.757-.715m0-.993a.993.993,0,0,0-.377.079l-1.757.715a1.946,1.946,0,0,0,1.469,3.6l1.767-.725a.993.993,0,0,0,.606-1.32l-.725-1.757a.993.993,0,0,0-.913-.625Z",
    transform: "translate(-6.218 -0.601)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117881",
    "data-name": "Path 117881",
    d: "M219.977,12.873a.993.993,0,0,1,.367,1.837l-1.767.715-.715-1.767,1.757-.715a1.142,1.142,0,0,1,.357-.069m0-.993a1.817,1.817,0,0,0-.725.149l-1.767.715a.993.993,0,0,0-.536,1.291l.715,1.757a.993.993,0,0,0,.526.546,1.082,1.082,0,0,0,.387.079.993.993,0,0,0,.377-.079l1.757-.715a1.916,1.916,0,0,0,1.062-1.042,1.956,1.956,0,0,0-1.8-2.7Z",
    transform: "translate(-6.145 -0.632)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117882",
    "data-name": "Path 117882",
    d: "M253.166,25.058a3.276,3.276,0,0,1-1.3-.268,3.326,3.326,0,0,1-1.8-1.807,3.286,3.286,0,0,1-.189-1.926.506.506,0,1,1,.993.2,2.413,2.413,0,0,0,.129,1.35,2.363,2.363,0,0,0,1.271,1.281,2.3,2.3,0,0,0,1.8,0,.5.5,0,0,1,.377.923,3.475,3.475,0,0,1-1.281.248Z",
    transform: "translate(-6.384 -0.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117883",
    "data-name": "Path 117883",
    d: "M255.819,21.11a.5.5,0,0,1-.467-.308,2.343,2.343,0,0,0-1.261-1.281,2.373,2.373,0,0,0-1.807,0,.5.5,0,0,1-.367-.923,3.356,3.356,0,0,1,4.358,1.837.506.506,0,0,1-.278.655A.566.566,0,0,1,255.819,21.11Z",
    transform: "translate(-6.397 -0.679)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117884",
    "data-name": "Path 117884",
    d: "M48.826,69.054c-.268,5.8-6.661,5.48-6.661,5.48H39.107a7.3,7.3,0,0,1-6.056,1.926,7.85,7.85,0,0,0-5.43,7.416c0,5.808-.05,4.606-.05,4.606h-2.79V78.555s-3.058-.864-3.117-3.157A6.364,6.364,0,0,1,18.12,69.63h0c1.837.576,3.574.993,4.547.675,2.651-.764,2.422-2.5,4.626-1.191a7.882,7.882,0,0,1,3.078,3.495,4.636,4.636,0,0,0,2.978-1.43c.278-.248,1.469,1.241,1.469,1.241s5.252-.546,5.093-5.52c0,0,6.056,5.47,8.875.536A9.074,9.074,0,0,1,48.826,69.054Z",
    transform: "translate(-4.706 -1.031)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117885",
    "data-name": "Path 117885",
    d: "M19.8,98.76a.993.993,0,0,1-.993-.993V82.1A17.2,17.2,0,0,1,13.35,69.93a16.956,16.956,0,0,1,4.964-12.36A18.138,18.138,0,0,1,31.22,52.1h5.857A18.743,18.743,0,0,1,52.4,60.042c1.271,1.807,1.261,6.254,1.211,7.8.993,1.281,4.457,5.808,5.123,7.307a3.713,3.713,0,0,1-3.405,5.232h-2.76v7.446a6.463,6.463,0,0,1-6.453,6.453H40.323a.993.993,0,1,1,0-1.985h5.788a4.477,4.477,0,0,0,4.467-4.467V79.4a.993.993,0,0,1,.993-.993h3.713a1.727,1.727,0,0,0,1.588-2.442,68.695,68.695,0,0,0-5.093-7.178.993.993,0,0,1-.208-.655c.089-2.095-.05-5.827-.834-6.949a16.778,16.778,0,0,0-13.7-7.108H31.18A16.142,16.142,0,0,0,19.694,58.95a15.05,15.05,0,0,0-4.358,10.92A15.219,15.219,0,0,0,20.458,80.92a.993.993,0,0,1,.338.745v16.1A.993.993,0,0,1,19.8,98.76Z",
    transform: "translate(-4.671 -0.923)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117886",
    "data-name": "Path 117886",
    d: "M24.774,89.363a.993.993,0,0,1-.993-.993V79.138a4.865,4.865,0,0,1-3.048-3.217,7.277,7.277,0,0,1-3.6-6.383c0-3.6,1.737-5.232,2.68-5.847a6.86,6.86,0,0,1,2.81-4.884,8.935,8.935,0,0,1,4.845-1.469h0a7.188,7.188,0,0,1,5.023-1.807,6.542,6.542,0,0,1,4.4,1.241c1.271-.1,4.438-.179,6.314,1.34a7.217,7.217,0,0,1,2.333,2.978c1.807.814,4.477,3.226,4.259,7.942a6.225,6.225,0,0,1-1.986,4.517,8.667,8.667,0,0,1-5.708,1.9H39.5a8.488,8.488,0,0,1-6.334,1.986,7.078,7.078,0,0,0-4.249,4.229,14.485,14.485,0,0,0-.318,2.2l-.05,4.517a.993.993,0,0,1-.993.993h0a.993.993,0,0,1-.993-.993l.069-4.587a15.606,15.606,0,0,1,.4-2.71,9.114,9.114,0,0,1,5.728-5.639,1.062,1.062,0,0,1,.4,0,6.324,6.324,0,0,0,5.222-1.618.993.993,0,0,1,.735-.318h3.058c5.281.228,5.639-4.041,5.659-4.537.228-4.9-3.236-6.1-3.385-6.145a.993.993,0,0,1-.635-.874h0a4.775,4.775,0,0,0-1.787-2.3c-1.36-1.092-4.3-.993-5.321-.854a.993.993,0,0,1-.993-.467h0s-.715-.814-3.167-.814a4.964,4.964,0,0,0-3.872,1.459.993.993,0,0,1-.893.377,6.949,6.949,0,0,0-4.06,1.132,5.172,5.172,0,0,0-1.986,3.862.993.993,0,0,1-.635.9c-.069,0-1.986.893-1.986,4.309A5.321,5.321,0,0,0,22.084,74.4a.993.993,0,0,1,.586.884c0,1.509,2.373,2.224,2.393,2.224a.993.993,0,0,1,.725.993V88.43A.993.993,0,0,1,24.774,89.363Z",
    transform: "translate(-4.699 -0.948)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117887",
    "data-name": "Path 117887",
    d: "M25.22,66.1a.993.993,0,0,1-.794-.4c-.069-.079-.9-.993-3.425-.377a1.02,1.02,0,1,1-.467-1.986c3.971-.933,5.361.993,5.51,1.162a.968.968,0,0,1-.824,1.6Z",
    transform: "translate(-4.718 -1.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117888",
    "data-name": "Path 117888",
    d: "M27.363,61.659a.993.993,0,0,1-.993-.923c0-.546-.069-2.373.993-3.167a1,1,0,1,1,1.2,1.588,3.087,3.087,0,0,0-.2,1.44.993.993,0,0,1-.923,1.062Z",
    transform: "translate(-4.766 -0.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117889",
    "data-name": "Path 117889",
    d: "M35.093,60.5a1.241,1.241,0,0,1-.318-.05.993.993,0,0,1-.625-1.261,3.633,3.633,0,0,1,3.495-2.442.993.993,0,1,1,0,1.986h0a1.648,1.648,0,0,0-1.5,1.092.993.993,0,0,1-1.052.675Z",
    transform: "translate(-4.822 -0.957)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117890",
    "data-name": "Path 117890",
    d: "M40.335,64.174A.993.993,0,0,1,39.4,63.5a1.271,1.271,0,0,0-1.41-.913,1,1,0,1,1-.238-1.986,3.256,3.256,0,0,1,3.485,2.263.993.993,0,0,1-.625,1.251A.854.854,0,0,1,40.335,64.174Z",
    transform: "translate(-4.842 -0.985)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117891",
    "data-name": "Path 117891",
    d: "M44.073,65.864a.988.988,0,0,1-.735-1.658,2.819,2.819,0,0,0,.655-2.154,1.009,1.009,0,0,1,1.986-.357,4.755,4.755,0,0,1-1.1,3.852A.993.993,0,0,1,44.073,65.864Z",
    transform: "translate(-4.887 -0.987)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117892",
    "data-name": "Path 117892",
    d: "M45.229,70.509a3.356,3.356,0,0,1-2.621-1.31A1,1,0,1,1,44.217,68a1.281,1.281,0,0,0,1.5.407,1,1,0,1,1,.665,1.876,3.554,3.554,0,0,1-1.152.228Z",
    transform: "translate(-4.882 -1.036)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117893",
    "data-name": "Path 117893",
    d: "M28.912,65.326h-.2a.968.968,0,0,1,.06-1.936,2.115,2.115,0,0,0,2.3-1.876,1,1,0,1,1,1.986.268A4.07,4.07,0,0,1,28.912,65.326Z",
    transform: "translate(-4.776 -0.985)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117894",
    "data-name": "Path 117894",
    d: "M33.444,77.5c-1.688,0-2.69-1.767-3.832-3.8a31.163,31.163,0,0,0-1.876-3.038,2.075,2.075,0,0,0-1.469-1.042,2.194,2.194,0,0,0-1.489.754,1,1,0,0,1-1.509-1.3,4.15,4.15,0,0,1,3.068-1.439,3.9,3.9,0,0,1,2.978,1.856A32.761,32.761,0,0,1,31.3,72.713c.7,1.251,1.578,2.8,2.115,2.8h.069a.993.993,0,1,1,0,1.986Z",
    transform: "translate(-4.742 -1.036)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117895",
    "data-name": "Path 117895",
    d: "M27.295,75.669a4.051,4.051,0,0,1-1.529-.288.993.993,0,0,1,.735-1.837,2.075,2.075,0,0,0,1.479,0,1.886,1.886,0,0,0,.794-1.34.994.994,0,1,1,1.946.407,3.713,3.713,0,0,1-1.817,2.68A3.385,3.385,0,0,1,27.295,75.669Z",
    transform: "translate(-4.757 -1.063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117896",
    "data-name": "Path 117896",
    d: "M21.8,77.081a.993.993,0,0,1-.993-.735,5.877,5.877,0,0,1,.665-4.1,1,1,0,0,1,1.708,1.023,3.772,3.772,0,0,0-.447,2.561.993.993,0,0,1-.7,1.221,1.142,1.142,0,0,1-.228.03Z",
    transform: "translate(-4.725 -1.066)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117897",
    "data-name": "Path 117897",
    d: "M42.773,99.059a.993.993,0,0,1-.993-.993V94.383a.993.993,0,0,1,1.986,0v3.683A.993.993,0,0,1,42.773,99.059Z",
    transform: "translate(-4.877 -1.222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117898",
    "data-name": "Path 117898",
    d: "M324.714,98.936a.993.993,0,0,1-.993-.993V88.72a10.4,10.4,0,0,0-10.483-10.335h-.606a16.48,16.48,0,0,1-14.028,0H298A10.4,10.4,0,0,0,287.566,88.72v9.223a.993.993,0,0,1-1.986,0V88.72A12.39,12.39,0,0,1,298,76.4h.824a1.072,1.072,0,0,1,.427.1,14.524,14.524,0,0,0,12.737,0,.993.993,0,0,1,.427-.1h.824a12.39,12.39,0,0,1,12.469,12.32v9.223A.993.993,0,0,1,324.714,98.936Z",
    transform: "translate(-6.643 -1.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117899",
    "data-name": "Path 117899",
    d: "M313.245,77.4h-.824a15.418,15.418,0,0,1-13.591,0h-.824A11.387,11.387,0,0,0,286.58,88.727V97.95h38.142V88.727A11.387,11.387,0,0,0,313.245,77.4Z",
    transform: "translate(-6.65 -1.107)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117900",
    "data-name": "Path 117900",
    d: "M295.5,67.359a10.99,10.99,0,1,0,3.167-12.906,9.976,9.976,0,0,0,.159-1.727c0-7.168-7.386-12.965-16.5-12.965s-16.51,5.8-16.51,12.965,7.386,12.965,16.51,12.965a20.054,20.054,0,0,0,6.949-1.211,15.566,15.566,0,0,0,6.225,2.879Z",
    transform: "translate(-6.5 -0.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117901",
    "data-name": "Path 117901",
    d: "M282.608,60.354A25.553,25.553,0,0,1,265.9,54c.784,6.592,7.833,11.744,16.43,11.744a20.054,20.054,0,0,0,6.949-1.211,15.06,15.06,0,0,0,9.064,3.207.516.516,0,0,0,.477-.3.506.506,0,0,0-.1-.546,15.765,15.765,0,0,1-3.534-5.957,11.626,11.626,0,0,0,3.574-6.671C294.64,57.336,289.021,60.354,282.608,60.354Z",
    transform: "translate(-6.501 -0.937)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117902",
    "data-name": "Path 117902",
    d: "M321.062,98.049H315.84V91.03Z",
    transform: "translate(-6.862 -1.205)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117903",
    "data-name": "Path 117903",
    d: "M290.49,98.049h5.222V91.03Z",
    transform: "translate(-6.679 -1.205)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117904",
    "data-name": "Path 117904",
    d: "M310.749,53.28a11.256,11.256,0,0,1,1.41.844,10.92,10.92,0,0,1,2.075,6.393,11.049,11.049,0,0,1-11.109,11.01,11.268,11.268,0,0,1-4.06-.764c-.854-.338-1.142.218-.377.834A11.039,11.039,0,1,0,310.749,53.28Z",
    transform: "translate(-6.735 -0.932)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117905",
    "data-name": "Path 117905",
    d: "M324.714,98.936a.993.993,0,0,1-.993-.993V88.72a10.4,10.4,0,0,0-10.483-10.335h-.606a16.48,16.48,0,0,1-14.028,0H298A10.4,10.4,0,0,0,287.566,88.72v9.223a.993.993,0,0,1-1.986,0V88.72A12.39,12.39,0,0,1,298,76.4h.824a1.072,1.072,0,0,1,.427.1,14.524,14.524,0,0,0,12.737,0,.993.993,0,0,1,.427-.1h.824a12.39,12.39,0,0,1,12.469,12.32v9.223A.993.993,0,0,1,324.714,98.936Z",
    transform: "translate(-6.643 -1.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117906",
    "data-name": "Path 117906",
    d: "M324.714,98.936a.993.993,0,0,1-.993-.993V88.72a10.4,10.4,0,0,0-10.483-10.335h-.606a16.48,16.48,0,0,1-14.028,0H298A10.4,10.4,0,0,0,287.566,88.72v9.223a.993.993,0,0,1-1.986,0V88.72A12.39,12.39,0,0,1,298,76.4h.824a1.072,1.072,0,0,1,.427.1,14.524,14.524,0,0,0,12.737,0,.993.993,0,0,1,.427-.1h.824a12.39,12.39,0,0,1,12.469,12.32v9.223A.993.993,0,0,1,324.714,98.936Z",
    transform: "translate(-6.643 -1.099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117907",
    "data-name": "Path 117907",
    d: "M315.833,99.034a.993.993,0,0,1-.993-.993V90.993a.993.993,0,0,1,1.986,0v7.049A.993.993,0,0,1,315.833,99.034Z",
    transform: "translate(-6.855 -1.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117908",
    "data-name": "Path 117908",
    d: "M295.633,99.034a.993.993,0,0,1-.993-.993V90.993a.993.993,0,1,1,1.985,0v7.049A.993.993,0,0,1,295.633,99.034Z",
    transform: "translate(-6.709 -1.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117909",
    "data-name": "Path 117909",
    d: "M301.438,66a.288.288,0,0,0-.268.347,4.726,4.726,0,0,0,9.124,0,.288.288,0,0,0-.278-.347Z",
    transform: "translate(-6.756 -1.024)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117910",
    "data-name": "Path 117910",
    d: "M298.306,68.642a16.033,16.033,0,0,1-9.233-3.087,21.225,21.225,0,0,1-6.751,1.092c-9.65,0-17.5-6.264-17.5-13.958s7.853-13.958,17.5-13.958,17.492,6.225,17.492,13.958a12.26,12.26,0,0,1-3.544,8.429,15.538,15.538,0,0,0,3.117,4.964,1.469,1.469,0,0,1,.3,1.648A1.489,1.489,0,0,1,298.306,68.642Zm-.328-1.132Zm-8.736-4.06a.993.993,0,0,1,.606.208,14.345,14.345,0,0,0,7.346,2.978,15.458,15.458,0,0,1-2.978-5.52.993.993,0,0,1,.268-.993,10.275,10.275,0,0,0,3.375-7.436c0-6.6-6.949-11.973-15.507-11.973s-15.517,5.371-15.517,11.973,6.949,11.973,15.517,11.973a19.13,19.13,0,0,0,6.582-1.152A.993.993,0,0,1,289.242,63.45Z",
    transform: "translate(-6.493 -0.827)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117911",
    "data-name": "Path 117911",
    d: "M282.658,55.606h-8.816a.993.993,0,0,1,0-1.986h8.816a.993.993,0,1,1,0,1.986Z",
    transform: "translate(-6.551 -0.934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117912",
    "data-name": "Path 117912",
    d: "M290.869,51.4H273.843a.993.993,0,0,1,0-1.986h17.026a.993.993,0,1,1,0,1.986Z",
    transform: "translate(-6.551 -0.904)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117913",
    "data-name": "Path 117913",
    d: "M305.7,75.065a12.14,12.14,0,0,1-7.643-2.709.993.993,0,1,1,1.249-1.5,10.08,10.08,0,1,0,6.443-17.8,10.245,10.245,0,0,0-2.859.4.993.993,0,0,1-.556-1.906,12.34,12.34,0,0,1,3.415-.477,12,12,0,1,1,0,23.995Z",
    transform: "translate(-6.73 -0.916)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10044",
    "data-name": "Ellipse 10044",
    cx: 9.014,
    cy: 9.014,
    rx: 9.014,
    ry: 9.014,
    transform: "translate(154.366 1.986)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117914",
    "data-name": "Path 117914",
    d: "M203.034,26.2H134.742a5.47,5.47,0,0,0,0,10.92h23.211V53a5.87,5.87,0,0,0-.278.834l-9.064,35.868a5.47,5.47,0,0,0,10.6,2.671l6.771-26.8h5.133l7.525,26.943a5.46,5.46,0,0,0,5.262,3.971,5.341,5.341,0,0,0,1.469-.2,5.46,5.46,0,0,0,3.8-6.731l-9.3-33.525V37.13h23.211a5.47,5.47,0,0,0,0-10.92Z",
    transform: "translate(-5.513 -0.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117915",
    "data-name": "Path 117915",
    d: "M169.1,2.536a9.024,9.024,0,1,1-9.024,9.014A9.024,9.024,0,0,1,169.1,2.536m0-1.986a11.01,11.01,0,1,0,11,11,11.01,11.01,0,0,0-11-11Z",
    transform: "translate(-5.72 -0.55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117916",
    "data-name": "Path 117916",
    d: "M203.02,26.185a5.47,5.47,0,0,1,0,10.92H179.81V56.048l9.3,33.525a5.46,5.46,0,0,1-3.8,6.731,5.341,5.341,0,0,1-1.469.2,5.46,5.46,0,0,1-5.262-3.971L171.1,65.588H165.97l-6.771,26.8a5.46,5.46,0,0,1-5.291,4.08,5.3,5.3,0,0,1-1.35-.169,5.47,5.47,0,0,1-3.971-6.632L157.651,53.8a5.861,5.861,0,0,1,.278-.834V37.086h-23.2a5.47,5.47,0,0,1,0-10.92H203.02m0-1.986H134.728a7.456,7.456,0,0,0,0,14.891h21.225V52.623a6.1,6.1,0,0,0-.218.725l-9.054,35.868a7.446,7.446,0,0,0,5.4,9.044,7.088,7.088,0,0,0,1.827.228,7.436,7.436,0,0,0,7.217-5.629l6.393-25.315h2.075l7.049,25.484a7.466,7.466,0,0,0,7.168,5.46,7.555,7.555,0,0,0,1.985-.268,7.466,7.466,0,0,0,5.192-9.173L181.8,55.77V39.1H203.02a7.456,7.456,0,0,0,0-14.891Z",
    transform: "translate(-5.499 -0.721)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117917",
    "data-name": "Path 117917",
    d: "M156.364,88.316C153.941,93.886,148.749,90,148.749,90a5.47,5.47,0,0,0,10.6,2.671l6.771-26.8C161,65.86,158.8,82.747,156.364,88.316Z",
    transform: "translate(-5.651 -1.023)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117918",
    "data-name": "Path 117918",
    d: "M152.411,31.63H129.28a5.46,5.46,0,0,0,5.46,5.54h23.211A5.54,5.54,0,0,0,152.411,31.63Z",
    transform: "translate(-5.511 -0.775)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117919",
    "data-name": "Path 117919",
    d: "M208.818,31.63H180.157c-6.949,0-3.723,27.847-3.723,27.847s7.753,25.444,6.3,28.79c-.764,1.787-2.74,2.095-4.438,1.986l.675,2.3a5.46,5.46,0,0,0,5.262,3.971,5.341,5.341,0,0,0,1.469-.2,5.46,5.46,0,0,0,3.8-6.731l-9.3-33.525V37.17h23.211a5.46,5.46,0,0,0,5.46-5.46S208.818,31.65,208.818,31.63Z",
    transform: "translate(-5.847 -0.775)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117920",
    "data-name": "Path 117920",
    d: "M177.436,8.09A19.408,19.408,0,0,1,163.21,18.355,9.007,9.007,0,0,0,177.466,8.09Z",
    transform: "translate(-5.757 -0.605)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117921",
    "data-name": "Path 117921",
    d: "M121.249,42.315c2.74,0,5.957,1.708,8.677,7.664,2.551,5.53-.576,10.047-2.532,12.151a3.862,3.862,0,0,1-2.8,1.211h-.288a2.72,2.72,0,0,0-2.134.993h0a3.842,3.842,0,0,1-2.839,1.479h-.7c-2.978,0-7.833-.854-10.2-5.957-6.175-13.372,5.381-14.5,6.314-14.574.357-.367,3.087-2.978,6.5-2.978m0-1.986a11.764,11.764,0,0,0-7.386,3.1c-1.807.258-5.887,1.221-7.992,4.8-1.866,3.157-1.608,7.366.764,12.5,2.859,6.195,8.746,7.118,11.993,7.118h.794a5.857,5.857,0,0,0,4.309-2.244.764.764,0,0,1,.576-.278h.288a5.857,5.857,0,0,0,4.229-1.827c4.041-4.338,5.093-9.57,2.889-14.345-1.856-4.021-5.182-8.816-10.484-8.816Z",
    transform: "translate(-5.333 -0.838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117922",
    "data-name": "Path 117922",
    d: "M129.93,49.944c2.561,5.54-.566,10.057-2.522,12.161a3.812,3.812,0,0,1-2.978,1.2,2.69,2.69,0,0,0-2.254.993,3.971,3.971,0,0,1-2.829,1.529,14.018,14.018,0,0,1-4.656-.546,9.66,9.66,0,0,1-6.244-5.411c-6.175-13.372,5.381-14.5,6.3-14.574.486-.477,4.874-4.726,9.61-2.234C126.237,44.1,128.173,46.172,129.93,49.944Z",
    transform: "translate(-5.347 -0.852)",
    fill: "#dc6127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117923",
    "data-name": "Path 117923",
    d: "M129.989,49.95c2.561,5.54-.566,10.057-2.522,12.161a3.812,3.812,0,0,1-2.978,1.2,2.69,2.69,0,0,0-2.254.993,3.971,3.971,0,0,1-2.829,1.529,14.018,14.018,0,0,1-4.656-.546c10.3-7.793,10.652-16.877,9.669-22.218C126.3,44.1,128.232,46.177,129.989,49.95Z",
    transform: "translate(-5.406 -0.858)",
    fill: "#c2470d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117924",
    "data-name": "Path 117924",
    d: "M113.477,35.244c-1.291,3.495,1.41,7.714,1.41,7.714s4.8-1.459,6.086-4.964-1.41-7.724-1.41-7.724S114.768,31.739,113.477,35.244Z",
    transform: "translate(-5.394 -0.765)",
    fill: "#75b052"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117925",
    "data-name": "Path 117925",
    d: "M119.474,30.31l-4.626,12.6c-.338-.556-2.561-4.408-1.37-7.644S118.858,30.509,119.474,30.31Z",
    transform: "translate(-5.394 -0.766)",
    fill: "#82c45b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117926",
    "data-name": "Path 117926",
    d: "M114.88,43.943a.993.993,0,0,1-.834-.457c-.119-.189-2.978-4.676-1.509-8.6h0c1.449-3.921,6.512-5.5,6.731-5.569a.993.993,0,0,1,1.122.417c.119.189,2.978,4.676,1.509,8.6s-6.513,5.5-6.731,5.569A.913.913,0,0,1,114.88,43.943Zm-.477-8.369c-.824,2.234.3,4.964.933,6.155,1.281-.536,3.882-1.856,4.7-4.08s-.3-4.964-.933-6.145C117.818,32.03,115.217,33.35,114.4,35.574Z",
    transform: "translate(-5.387 -0.758)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117927",
    "data-name": "Path 117927",
    d: "M115.216,47.275a.993.993,0,0,1-.993-.933c0-.149-.278-3.187-4.676-6.244a.993.993,0,0,1,1.132-1.628c5.281,3.673,5.52,7.6,5.52,7.773a.993.993,0,0,1-.993.993Z",
    transform: "translate(-5.365 -0.824)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117928",
    "data-name": "Path 117928",
    d: "M98.34,71.875a2.522,2.522,0,0,0-1.44-1.261l.357-3.356-1.33-.139-.357,3.405h-.079a5.589,5.589,0,0,0-3.038,3.425c-.993,2.72-3.405,10.821-17.135,14.157-8.577,2.085-3.276,8.448,5.093,8.29,6.84-.139,12.241-3.038,15.08-7.366S101.457,79.063,98.34,71.875Z",
    transform: "translate(-5.089 -1.032)",
    fill: "#edc729"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117929",
    "data-name": "Path 117929",
    d: "M95.958,69a1.856,1.856,0,0,0-.189-.318l-.2,1.906h-.079a5.589,5.589,0,0,0-3.038,3.375c-.993,2.72-3.405,10.821-17.135,14.157-3.286.794-4.527,2.224-4.348,3.663a13.442,13.442,0,0,0,7.059,1.688c6.84-.139,12.241-3.048,15.08-7.366S99.075,76.126,95.958,69Z",
    transform: "translate(-5.089 -1.043)",
    fill: "#fcda4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117930",
    "data-name": "Path 117930",
    d: "M98.184,71.379,94.58,71,96.1,67.12l1.33.139Z",
    transform: "translate(-5.26 -1.032)",
    fill: "#b87631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117931",
    "data-name": "Path 117931",
    d: "M95.913,67.106l1.33.139-.278,2.72a.993.993,0,0,0,.4.923,3.723,3.723,0,0,1,.993.993c3.117,7.188,0,12.816-2.849,17.145s-8.24,7.227-15.08,7.366H80.1c-8.18,0-13.233-6.235-4.765-8.29,13.7-3.356,16.073-11.456,17.105-14.167A6.066,6.066,0,0,1,94.8,70.957a1.847,1.847,0,0,0,.854-1.36l.258-2.432m0-1.986a1.985,1.985,0,0,0-1.986,1.777L93.68,69.31a8.061,8.061,0,0,0-3.107,3.971l-.159.427c-1.042,2.81-3.544,9.511-15.586,12.449-5.748,1.39-6.006,4.537-5.847,5.827.427,3.574,5.3,6.374,11.089,6.374h.357c7.267-.149,13.363-3.157,16.708-8.26,3.524-5.371,6.334-11.387,2.978-19.031l-.119-.228A5.579,5.579,0,0,0,99,69.6l.228-2.144a2.045,2.045,0,0,0-.447-1.459,1.986,1.986,0,0,0-1.33-.725l-1.33-.139Z",
    transform: "translate(-5.074 -1.018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117932",
    "data-name": "Path 117932",
    d: "M255.962,77.28a.745.745,0,0,1,.635.844l-.228,1.569a41.3,41.3,0,0,1-1.787,7.426l5.957-6.076,1.608,1.578-6.185,6.294a35.42,35.42,0,0,1,5.113-1.489l3.723-.764a.754.754,0,0,1,.3,1.469l-3.7.764a33.189,33.189,0,0,0-6.642,2.124l-.745.328a4.338,4.338,0,0,0-1.36.993l-.129.129a.655.655,0,0,1-.933,0l-.665-.655a.655.655,0,0,1,0-.933h0a7.167,7.167,0,0,0,1.549-2.422,39.433,39.433,0,0,0,2.363-8.935l.228-1.559a.745.745,0,0,1,.9-.685Z",
    transform: "translate(-6.391 -1.106)",
    fill: "#5d913c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117933",
    "data-name": "Path 117933",
    d: "M250.919,90.817a7.167,7.167,0,0,0,1.549-2.422,39.43,39.43,0,0,0,2.363-8.935l1.31,1.291a41.931,41.931,0,0,1-1.608,6.354l3.971-4.031.189.189-.248,1.519-7.287,7.148-.208-.208a.655.655,0,0,1-.03-.9Z",
    transform: "translate(-6.391 -1.122)",
    fill: "#82c45b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117934",
    "data-name": "Path 117934",
    d: "M262.538,71.383a3.227,3.227,0,0,1,3.127,2.492,5.013,5.013,0,0,1,1.221-.149,5.331,5.331,0,0,1,3.733,1.549,5.073,5.073,0,0,1,.258,7.168l-.179.169A4.477,4.477,0,0,1,270,87.793a4.259,4.259,0,0,1-3.107,1.271A4.825,4.825,0,0,1,263.68,87.8h0a2.2,2.2,0,0,1-1.588.655,2.462,2.462,0,0,1-1.718-.715,2.422,2.422,0,0,1-.655-2.353,3.624,3.624,0,0,1-1.638.4,3.792,3.792,0,0,1-2.671-1.112,3.653,3.653,0,0,1-.189-5.172l-.228-.228a4.05,4.05,0,0,1-.218-5.728,3.832,3.832,0,0,1,2.75-1.132,4.209,4.209,0,0,1,2.333.715,2.979,2.979,0,0,1,.6-.913,2.9,2.9,0,0,1,2.065-.844m0-.993a3.852,3.852,0,0,0-2.77,1.142c-.089.1-.179.189-.258.288a5.1,5.1,0,0,0-1.986-.387,4.8,4.8,0,0,0-3.455,1.43,5.033,5.033,0,0,0-.159,6.721,4.468,4.468,0,0,0-.665,2.532A4.815,4.815,0,0,0,254.7,85.38a4.755,4.755,0,0,0,3.365,1.4,4.7,4.7,0,0,0,.645,0,3.475,3.475,0,0,0,.993,1.727,3.415,3.415,0,0,0,2.412.993,3.236,3.236,0,0,0,1.588-.407,5.689,5.689,0,0,0,3.226.993,5.242,5.242,0,0,0,3.782-1.569,5.391,5.391,0,0,0,1.161-5.659,5.788,5.788,0,0,0,1.36-3.971,6.423,6.423,0,0,0-6.334-6.155h-.576a4.209,4.209,0,0,0-3.772-2.373Z",
    transform: "translate(-6.405 -1.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117935",
    "data-name": "Path 117935",
    d: "M254.812,73.564a4.06,4.06,0,0,0,.208,5.738l.218.218a3.782,3.782,0,0,0,4.507,5.877,2.413,2.413,0,0,0,.655,2.363,2.343,2.343,0,0,0,3.306.06h0a4.537,4.537,0,0,0,6.294,0,3.444,3.444,0,0,0,.616-.814,4.5,4.5,0,0,0,.079-4.368l.189-.169a5.083,5.083,0,0,0-.268-7.158,5.242,5.242,0,0,0-4.964-1.4,3.236,3.236,0,0,0-.884-1.578,3.117,3.117,0,0,0-3.455-.665h-.05a2.769,2.769,0,0,0-.794.566,2.879,2.879,0,0,0-.606.913,4.09,4.09,0,0,0-4.269-.208A3.446,3.446,0,0,0,254.812,73.564Z",
    transform: "translate(-6.412 -1.063)",
    fill: "#5d913c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117936",
    "data-name": "Path 117936",
    d: "M255.627,72.989a4.14,4.14,0,0,0,.834,4.9l.218.218a3.673,3.673,0,0,0,.2,5.172,3.713,3.713,0,0,0,4.309.715,2.432,2.432,0,0,0,.655,2.363,2.343,2.343,0,0,0,3.306.06h0a4.616,4.616,0,0,0,5.48.635,4.5,4.5,0,0,0,.079-4.368l.189-.169a5.083,5.083,0,0,0-.268-7.158,5.242,5.242,0,0,0-4.964-1.4,3.236,3.236,0,0,0-.884-1.578,3.117,3.117,0,0,0-3.455-.665h0a2.769,2.769,0,0,0-.794.566,2.878,2.878,0,0,0-.606.913A4.09,4.09,0,0,0,255.627,72.989Z",
    transform: "translate(-6.423 -1.064)",
    fill: "#82c45b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117937",
    "data-name": "Path 117937",
    d: "M262.984,77.968a.407.407,0,0,1-.159,0,.506.506,0,0,1-.318-.635c.576-1.658-1.5-2.829-1.519-2.839a.5.5,0,0,1-.2-.675.506.506,0,0,1,.675-.2c.993.546,2.651,2.085,1.986,4.041A.487.487,0,0,1,262.984,77.968Z",
    transform: "translate(-6.463 -1.079)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117938",
    "data-name": "Path 117938",
    d: "M266.41,82.059h-.119a.486.486,0,0,1-.318-.238c-.05-.089-1.241-2.134-2.978-1.519a.5.5,0,0,1-.337-.933c1.747-.635,3.2.6,3.9,1.578a1.986,1.986,0,0,1,1.539.069.5.5,0,1,1-.467.884,1.052,1.052,0,0,0-.993.1A.5.5,0,0,1,266.41,82.059Z",
    transform: "translate(-6.475 -1.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117939",
    "data-name": "Path 117939",
    d: "M262.509,71.376a3.227,3.227,0,0,1,3.127,2.5,4.636,4.636,0,0,1,1.221-.159,5.341,5.341,0,0,1,3.733,1.559,5.083,5.083,0,0,1,.268,7.158l-.189.169a4.5,4.5,0,0,1-.079,4.368,3.444,3.444,0,0,1-.616.814,4.229,4.229,0,0,1-3.058,1.261,4.765,4.765,0,0,1-2.681-.834l-2.849.586a33.187,33.187,0,0,0-6.642,2.125l-.745.328a4.338,4.338,0,0,0-1.36.993l-.129.129a.665.665,0,0,1-.467.2.655.655,0,0,1-.467-.189l-.665-.655a.655.655,0,0,1,0-.933,7.168,7.168,0,0,0,1.549-2.422,40.639,40.639,0,0,0,1.817-5.957,3.534,3.534,0,0,1,.407-2.1,6.215,6.215,0,0,1,.139-.824v-.278a4.041,4.041,0,0,1-.079-5.589,3.445,3.445,0,0,1,.8-.625,3.911,3.911,0,0,1,1.936-.506,4.209,4.209,0,0,1,2.333.715,2.879,2.879,0,0,1,.606-.913,2.77,2.77,0,0,1,.794-.566h.05a2.829,2.829,0,0,1,1.211-.258M254.488,87.15l1.727-1.757a3.871,3.871,0,0,1-.844-.625l-.129-.149c-.228.854-.467,1.7-.755,2.532m1.459,1.708a33.187,33.187,0,0,1,4.249-1.271,2.422,2.422,0,0,1-.5-2.164,2.909,2.909,0,0,1-.635.248l-3.117,3.187M262.5,69.43a4.8,4.8,0,0,0-1.936.4,1.269,1.269,0,0,0-.238.109,4.665,4.665,0,0,0-1.132.774,5.957,5.957,0,0,0-4.606.526,5.649,5.649,0,0,0-1.241.993,5.957,5.957,0,0,0-.606,7.5,5.44,5.44,0,0,0-.486,2.541,36.739,36.739,0,0,1-1.658,5.4,5.273,5.273,0,0,1-1.122,1.757,2.641,2.641,0,0,0,0,3.733l.665.665a2.651,2.651,0,0,0,1.856.755,2.611,2.611,0,0,0,1.886-.794l.129-.129a2.4,2.4,0,0,1,.735-.516l.754-.328a31.242,31.242,0,0,1,6.234-1.986l2.1-.437a6.731,6.731,0,0,0,3.028.725,6.185,6.185,0,0,0,4.477-1.856,5.323,5.323,0,0,0,.913-1.211,6.4,6.4,0,0,0,.635-4.964,6.741,6.741,0,0,0,1.241-4.209,7.4,7.4,0,0,0-7.267-7.138h0a5.677,5.677,0,0,0-.7-.844,5.132,5.132,0,0,0-3.633-1.5Z",
    transform: "translate(-6.376 -1.049)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117940",
    "data-name": "Path 117940",
    d: "M137.852,3.735a1.519,1.519,0,0,1,1.171.536,1.618,1.618,0,0,1-.248,2.254l-.258.218,2.77-.933a1.568,1.568,0,0,1,.516-.089A1.5,1.5,0,0,1,143.253,6.8a1.678,1.678,0,0,1-1.092,2.035l-2.77.933h.328a1.5,1.5,0,0,1,1.39,1.708,1.7,1.7,0,0,1-1.658,1.489h-.109l-5.47-.367a1.509,1.509,0,0,1-1.35-1.082,1.588,1.588,0,0,1,0-.536,1.529,1.529,0,0,1-.238-.477,1.638,1.638,0,0,1-.05-.536A1.39,1.39,0,0,1,132,9.5a1.648,1.648,0,0,1,.536-1.717l4.289-3.673a1.678,1.678,0,0,1,1.082-.4m0-1.986a3.663,3.663,0,0,0-2.373.874l-4.289,3.673a3.643,3.643,0,0,0-1.162,3.772,4.26,4.26,0,0,0,.189.5,3.186,3.186,0,0,0,.109.516,2.9,2.9,0,0,0,.189.486,2.8,2.8,0,0,0,.1.516,3.5,3.5,0,0,0,3.127,2.512l5.46.377h.248a3.663,3.663,0,0,0,3.633-3.236,3.792,3.792,0,0,0,0-1.112,3.693,3.693,0,0,0,2.125-4.368,3.475,3.475,0,0,0-3.365-2.522,3.713,3.713,0,0,0-.745.079,3.8,3.8,0,0,0-.516-.824,3.514,3.514,0,0,0-2.69-1.241Z",
    transform: "translate(-5.516 -0.559)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117941",
    "data-name": "Path 117941",
    d: "M132.714,10.451a1.39,1.39,0,0,1-.467-.367A1.618,1.618,0,0,1,132.5,7.82l4.289-3.673a1.588,1.588,0,0,1,2.254.139,1.618,1.618,0,0,1-.248,2.254l-4.3,3.673a1.618,1.618,0,0,1-1.777.238Z",
    transform: "translate(-5.53 -0.573)",
    fill: "#75b052"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117942",
    "data-name": "Path 117942",
    d: "M133.3,12.518a1.529,1.529,0,0,1-.814-1.549,1.708,1.708,0,0,1,1.777-1.489l5.47.367a1.5,1.5,0,0,1,1.39,1.708,1.688,1.688,0,0,1-1.777,1.489l-5.46-.367a1.9,1.9,0,0,1-.586-.159Z",
    transform: "translate(-5.534 -0.615)",
    fill: "#75b052"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117943",
    "data-name": "Path 117943",
    d: "M132.994,11.478a1.509,1.509,0,0,1-.755-.923,1.7,1.7,0,0,1,1.092-2.035l7.942-2.68a1.509,1.509,0,0,1,1.986.993,1.678,1.678,0,0,1-1.092,2.035l-7.942,2.69a1.608,1.608,0,0,1-1.231-.079Z",
    transform: "translate(-5.532 -0.588)",
    fill: "#82c45b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117944",
    "data-name": "Path 117944",
    d: "M142.491,5.911a1.459,1.459,0,0,1,.754.913,1.678,1.678,0,0,1-1.092,2.035L130.32,11.748l-.288-.993,11.248-4.9a1.588,1.588,0,0,1,1.211.079m.516-.993a2.651,2.651,0,0,0-1.985-.129h-.089L129.655,9.763a1.122,1.122,0,0,0-.645,1.32l.288.993a.993.993,0,0,0,.506.616,1.062,1.062,0,0,0,.725.079l11.824-2.879h.089a2.819,2.819,0,0,0,1.837-3.385A2.492,2.492,0,0,0,143.008,5Z",
    transform: "translate(-5.509 -0.58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117945",
    "data-name": "Path 117945",
    d: "M130.382,8.256A21.93,21.93,0,0,0,106,19.375c8.786,4.428,19.557,1.747,25.911-5.867Z",
    transform: "translate(-5.342 -0.602)",
    fill: "#e66f26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117946",
    "data-name": "Path 117946",
    d: "M107.31,17.27a21.612,21.612,0,0,0,23.727-6.79l-.645-2.224A21.841,21.841,0,0,0,107.31,17.27Z",
    transform: "translate(-5.352 -0.602)",
    fill: "#ff883d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117947",
    "data-name": "Path 117947",
    d: "M125.245,11.42a.993.993,0,0,1-.993-.715l-.993-3.455a.993.993,0,1,1,1.906-.556l.993,3.465a.993.993,0,0,1-.675,1.221.893.893,0,0,1-.238.04Z",
    transform: "translate(-5.467 -0.589)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117948",
    "data-name": "Path 117948",
    d: "M119.06,15.024a.993.993,0,0,1-.993-.715l-1.648-5.7a.993.993,0,1,1,1.906-.546l1.648,5.7a.993.993,0,0,1-.675,1.221.893.893,0,0,1-.238.04Z",
    transform: "translate(-5.418 -0.599)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117949",
    "data-name": "Path 117949",
    d: "M112.285,16.32a.993.993,0,0,1-.993-.715l-.993-3.465a.991.991,0,0,1,1.906-.546l.993,3.455a.993.993,0,0,1-.675,1.231A.854.854,0,0,1,112.285,16.32Z",
    transform: "translate(-5.373 -0.625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117950",
    "data-name": "Path 117950",
    d: "M125.364,7.606a20.59,20.59,0,0,1,4.9.6h.1l1.519,5.252a22.089,22.089,0,0,1-16.877,8,20.083,20.083,0,0,1-9.024-2.095A22.228,22.228,0,0,1,125.364,7.606m0-1.986a24.084,24.084,0,0,0-21.136,12.8,1.986,1.986,0,0,0,.854,2.71,21.841,21.841,0,0,0,9.928,2.363,24.263,24.263,0,0,0,18.376-8.726,1.986,1.986,0,0,0,.4-1.817l-1.519-5.262a1.986,1.986,0,0,0-1.251-1.32l-.278-.089a22.178,22.178,0,0,0-5.381-.655Z",
    transform: "translate(-5.328 -0.587)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllWelcomecollage);
export default __webpack_public_path__ + "static/media/ill_welcomecollage.f2a9a4a5ee50d79095cf6cc58cdfa6e1.svg";
export { ForwardRef as ReactComponent };